"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getNodePath(parent, step) {
    return `${parent ? `${getNodePath(parent.props.parent, parent.props.step)} > ` : ""}${!step
        ? "{}"
        : step.type === "GetFieldStep"
            ? `${step.fieldName}(${JSON.stringify(step.fieldArguments)})`
            : `[${step.index}]`}`;
}
exports.default = getNodePath;
//# sourceMappingURL=getNodePath.js.map